// extracted by mini-css-extract-plugin
module.exports = {"root":"MatrixPets-module__root___O5cmC"};